import Sugar from "sugar";
import { useEffect, useRef } from "react";

Sugar.extend();

function isSameScorecard(x, y) {
  return (
    x &&
    y &&
    x.degreeLevel === y.degreeLevel &&
    x.unitid === y.unitid &&
    x.cipCode === y.cipCode
  );
}

function isSameMajor(x, y) {
  return x && y && x.cipCode === y.cipCode && x.degreeLevel === y.degreeLevel;
}

function getHighestLowest(rank, count) {
  const descriptor = rank <= count / 2 || count === 1 ? "highest" : "lowest";
  const displayRank = rank <= count / 2 ? rank : count + 1 - rank;
  if (rank === 1 || rank === count) return descriptor.capitalize();
  else return `${displayRank.ordinalize()} ${descriptor}`;
}

function isMainCampus(x) {
  return x && x.opeid == Sugar.String.padRight(x.opeid6, 8, "0");
}

function getMainCampus(x, data) {
  return data
    .filter(y => y.opeid6 === x.opeid6)
    .filter(isMainCampus)
    .first();
}

function addSearchParam(search, param) {
  const params = Object.fromQueryString(search);
  const newSearch = Object.add(params, param);
  return Object.toQueryString(newSearch);
}

function deleteSearchParam(search, key) {
  const params = Object.fromQueryString(search);
  const newSearch = Object.reject(params, key);
  return Object.toQueryString(newSearch);
}

const hyphenated = ["All-State", "Goldey-Beacom", "Wilkes-Barre"];
function splitSchoolName(schoolName) {
  const replace = hyphenated.reduce(
    (acc, cur) => acc.replace(cur, cur.replace("-", "•")),
    schoolName
  );
  const [main, ...rest] = replace.split("-");
  const school = main.replace("•", "-");
  const campus = rest.join("-");
  return { school, campus };
}

function getSocialSlug(scorecard) {
  const { school, unitid, cipCode, degreeLevel } = scorecard;
  return `${school.parameterize()}/${unitid}-${cipCode}-${degreeLevel}`;
}

function getSocialUrl(scorecard) {
  return `https://media.inquirer.com/storage/inquirer/projects/innovation/2020_04_doesthatdegreepay/social/${getSocialSlug(
    scorecard
  )}.html`;
}



export {
  isSameScorecard,
  isSameMajor,
  isMainCampus,
  getHighestLowest,
  getMainCampus,
  splitSchoolName,
  getSocialSlug,
  getSocialUrl,
  addSearchParam,
  deleteSearchParam
};
